import i18n from "./i18n";
export const tWithKeyAttr = (key, params = {}) => {
  const translated = i18n.t(key, params);

  requestAnimationFrame(() => {
    // const candidates = document.querySelectorAll(`[data-i18n-key="${key}"]`);
    //
    // if (candidates.length === 0) {
    //   const elements = document.querySelectorAll("*");
    //
    //   elements.forEach((el) => {
    //     const elText = el.textContent;
    //
    //     // בדיקות לוגים
    //     if (typeof elText !== "string") {
    //       console.warn("el.textContent is not a string:", elText, el);
    //     }
    //     if (typeof translated !== "string") {
    //       console.warn(
    //         "translated is not a string:",
    //         translated,
    //         "for key:",
    //         key
    //       );
    //     }
    //
    //     // הגנה מפני undefined
    //     const safeElText = (elText || "").trim();
    //     const safeTranslated = (translated || "").trim();
    //
    //     if (safeElText === safeTranslated) {
    //       el.setAttribute("data-i18n-key", key);
    //     }
    //   });
    // }
  });

  return translated;
};
